// extracted by mini-css-extract-plugin
export default {"skeleton-date":"skeletonWorkedDays_skeleton-date__mKXDT"};